import { render, staticRenderFns } from "./etapa_2.vue?vue&type=template&id=4260386e&scoped=true&"
import script from "./etapa_2.vue?vue&type=script&lang=js&"
export * from "./etapa_2.vue?vue&type=script&lang=js&"
import style0 from "./etapa_2.vue?vue&type=style&index=0&id=4260386e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4260386e",
  null
  
)

export default component.exports